const MultiselectPlugin = {
    init: ($) => {
        if ($('[data-plugin="multiselect"]').length > 0) {
            $('[data-plugin="multiselect"]').multiSelect($(this).data());
        }
    },
};

export default MultiselectPlugin;
